import { ActionReducer, INIT, UPDATE } from '@ngrx/store';
import { isAdminRole } from '@core/models/roles';
import type { AppState } from './index';

const TOKEN_KEY = 'erp_token';
const USER_KEY  = 'erp_user';

export function storageMetaReducer(
  reducer: ActionReducer<AppState>,
): ActionReducer<AppState> {
  return (state, action) => {
    // Al iniciar la app, hidratar el slice auth desde localStorage
    if (action.type === INIT || action.type === UPDATE) {
      const token   = localStorage.getItem(TOKEN_KEY);
      const userRaw = localStorage.getItem(USER_KEY);
      if (token || userRaw) {
        let user = null;
        try { user = userRaw ? JSON.parse(userRaw) : null; } catch { /* ignorar */ }
        // Restaurar moduleAccess, fieldAccess e isAdmin desde el user guardado (incluido en el payload del login)
        const moduleAccess = (user as any)?.moduleAccess ?? [];
        const fieldAccess  = (user as any)?.fieldAccess  ?? [];
        // Misma regla que el login. Aquí se había quedado solo el rol 1, así
        // que un SUPER_ADMIN perdía el acceso total al recargar la página.
        const isAdmin = isAdminRole((user as any)?.idRole);
        return reducer(
          {
            ...state,
            auth: { token, user, moduleAccess, fieldAccess, isAdmin, loading: false, error: null },
          },
          action,
        );
      }
    }
    return reducer(state, action);
  };
}
